export default "__VITE_ASSET__kL29EcnG__"